import * as React from 'react';
import classnames from 'classnames';
import { colorMap } from '../variables';
import Base, { Props as BaseProps, TypeColors } from '../Base/Base';
import './ProgressBar.css';

export interface Props extends BaseProps {
  /** The color that is applied to the track */
  backgroundColor?: TypeColors;
  /** The color that is applied to the progressing bar  */
  foregroundColor: TypeColors;
  /** The height of the bar */
  height: string;
  /** A number between 0 and 1 that represents the progress to display */
  progress: number;
  /** Color of the stripes on the track */
  stripeColor?: TypeColors;
}

/**
 * A determinate progress indicatior
 */
const ProgressBar: React.FunctionComponent<Props> = (props: Props) => {
  const {
    borderRadius,
    foregroundColor,
    height,
    progress,
    stripeColor,
    ...rest
  } = props;

  const classes = classnames('ProgressBar', {
    'ProgressBar--striped': stripeColor,
  });

  const progressClamped = React.useMemo(() =>
    Math.max(0, Math.min(progress * 100, 100))
  , [progress]);

  return (
    <Base { ...rest }
        borderRadius={ borderRadius }
        className={ classes }
        height={ height }
        style={ {
          '--ProgressBar--height': height,
          '--ProgressBar--stripe-color': stripeColor ? colorMap[stripeColor] : '',
        } }>
      <Base
          backgroundColor={ foregroundColor }
          borderRadius={ borderRadius }
          className="ProgressBar__progress"
          width={ `${progressClamped}%` }/>
    </Base>
  );
};

export default ProgressBar;
